import React, { useState } from 'react';
// noinspection ES6CheckImport
import { Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ReactLoading from 'react-loading';
import firebase from '../../../config/firebase';
import 'firebase/auth';
import { logIn } from '../../../store/ducks/auth';

import Header from '../../molecules/Header';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import Txt from '../../atoms/Txt';

import * as S from './styles';
import { getUser } from '../../../database/repositories/UserRepository';

function LogInView() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [msgType, setMsgType] = useState();
  const [msg, setMsg] = useState();
  const [loading, setLoading] = useState();

  const dispatch = useDispatch();

  async function login() {
    if (!email || !password) {
      setMsgType('error');
      setMsg('É necessário informar o email e a senha para efetuar login.');
      return;
    }
    setLoading(true);
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        getUser(result.user.uid)
          .then((userData) => {
            setMsgType('success');
            setMsg('Login efetuado com sucesso!');

            setTimeout(() => {
              dispatch(logIn(result.user.uid, email, userData));
              setLoading(false);
            }, 2000);
          })
          .catch((getUserDataError) => {
            console.error(getUserDataError.message);
            setLoading(true);
          });
      })
      .catch(() => {
        setMsgType('error');
        setMsg('Problema de autenticação, verifique se senha e usuário estão corretos.');
        setLoading(false);
      });
  }

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) > 0 ? <Redirect to="/#top" /> : null}
      <Header />
      {/* <NavBar/> */}
      <MainContent>
        <div className="signup-form-holder">
          <form className="signup-form">
            <div className="email-form">
              <input onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" />
            </div>

            <div className="password-form">
              <input
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="Senha"
              />
            </div>

            {msgType === 'success' && (
              <Txt color="green" size="20px">
                {msg}
              </Txt>
            )}
            {msgType === 'error' && (
              <Txt color="red" size="20px" style={{ margin: "20px" }}>
                {msg}
              </Txt>
            )}

            <div className="login-btn">
              {loading ? (
                <ReactLoading type="spinningBubbles" color="#002666" height={60} width={59} />
              ) : (
                <button onClick={login} type="button">
                  Logar
                </button>
              )}
            </div>

            <div className="recovery-lnk">
              <Txt color="red" size="25px">
                Esqueceu a senha?{' '}
              </Txt>
              <Txt size="25px" href="/recuperar-senha">
                Recuperar senha
              </Txt>
            </div>
          </form>
        </div>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default LogInView;
